import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

type HeaderProps = {
    style?: any
    heading?: any
    subHeading?: string
    children?: React.ReactNode
}

const Header = (props: HeaderProps) => {
    return (
        <Box>
            {props?.children ?
                <>{props?.children}</>
                :
                <>
                    {props?.heading ? (
                        <Box textAlign={"center"}>
                            <Typography variant="h5" sx={{ fontWeight: 700, marginBottom: "1rem" }}>
                                {props.heading}
                            </Typography>
                        </Box>
                    ) : (
                        <></>
                    )}
                    {props?.subHeading ? < Typography sx={{ color: "#575F6E", fontSize: "1rem", textAlign: "center" }} variant="h6">
                        {props.subHeading}
                    </Typography> : <></>}
                </>
            }
        </Box>
    )
}
export default Header
